export default ['sm', 'md', 'lg'];
